import { Cookie } from 'ng2-cookies/ng2-cookies';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable()
export class AuthenticationService {

    redirectToAuthenticate() {
      window.location.href = environment.useSingleSignOn
        ? this.authenticateUrl
        : '/login';
    }

    isAuthenticated() {
      return !!(
        Cookie.get('userType')
        && Cookie.get('auth_token')
        && Cookie.get('auth_expires')
        && !this.isAuthExpired()
      );
    }

    private isAuthExpired() {
      const timestamp = Math.floor(new Date().getTime() / 1000);
      return parseInt(Cookie.get('auth_expires'), 10) < timestamp;
    }

    private get authenticateUrl() {
      return `https://lendio.okta.com/oauth2/v1/authorize
        ?client_id=${environment.oktaClientId}
        &response_type=${this.responseType}
        &redirect_uri=${this.redirectUri}
        &response_mode=form_post
        &scope=openid%20email
        &nonce=${this.nonce}
        &state=${this.state}`.replace(/\s+/g, '');
    }

    private get nonce() {
      return Math.random().toString(36).replace(/[^a-z]/, '').substr(2);
    }

    private get responseType() {
      return encodeURIComponent('id_token');
    }

    private get redirectUri() {
      return encodeURIComponent(`${environment.API_URL}/sso/okta/callback`);
    }

    private get state() {
      return encodeURIComponent(window.location.href);
    }
}
